import React from 'react'

import { AuthorLine as AuthorLineLeshenUI } from '@leshen/ui'

const AuthorLine = ({ date, fullName }) => (
  <AuthorLineLeshenUI date={date} fullName={fullName} />
)

export default AuthorLine
